const createInstance = (scope = {}) => {
    const shouldShowAdrRedemption = () => {
        return !scope.loyaltyCfg.inMaintenanceMode &&
            scope.loyaltyCfg.enabled &&
            !!scope.loyalty &&
            (scope.loyalty.optInStatus == 'YES' || scope.loyalty.optInStatus == true) &&
            !scope.hasOrderItems &&
            !!scope.hasAdrItems;
    };

    return {
        shouldShowAdrRedemption
    };
};

export default createInstance;
